import { useState, useEffect } from 'react';

import { useGetUsersQuery } from '../../common/apis/AdminApi';
import { UserFilterOption } from '../constants/FilterOptions';
import MenuOption from '../types/MenuOption';

const useFilteredUsers = (
  limit: number,
  userFilters: MenuOption<UserFilterOption>[],
  subscriptionFilters: MenuOption<UserFilterOption>[],
  sortParams: { sortField?: string; direction?: string },
  searchText?: string
) => {
  const { sortField, direction } = sortParams;
  const [page, setPage] = useState<number>(1);
  const [filterSubscriptions, setFilterSubscriptions] = useState<string[]>([]);
  const [onlyActiveUsers, setOnlyActiveUsers] = useState<boolean>(false);

  const { data, isFetching: isLoading } = useGetUsersQuery(
    {
      page: page,
      limit,
      search: searchText,
      sortField,
      direction,
      onlyActiveUsers: onlyActiveUsers,
      subscriptions: filterSubscriptions,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  useEffect(() => {
    setFilterSubscriptions(
      subscriptionFilters
        .filter((filter) => filter.selected)
        .map((filter) => filter.item.toLowerCase())
    );
  }, [subscriptionFilters]);

  useEffect(() => {
    // simple if because we have only 1 rule in that filter
    if (userFilters.filter((filter) => filter.selected).length) {
      setOnlyActiveUsers(true);
    } else {
      setOnlyActiveUsers(false);
    }
  }, [userFilters]);

  return {
    filteredUsers: data?.docs ?? [],
    isLoading,
    total: data?.total ?? 0,
    page,
    setPage,
  };
};

export default useFilteredUsers;
